module.exports = __webpack_public_path__ + "static/media/三溪堂.fa54889d.png";